import { action } from 'satcheljs';

export const setNow: () => {} = action('setNow');
export interface SetTodayActionMessage {
    today: number;
}
export const setToday: (today: number) => SetTodayActionMessage = action(
    'setToday',
    (today: number): SetTodayActionMessage => ({ today })
);
